import { useSelector } from 'react-redux';
import { DataTestId } from '@mews-commander/enums';
import { getDisableClickAwayProps } from '@optimus-web/helpers';
import { getCurrentUserMenuAccount } from '../selectors';
import { UserAvatarContainer, MenuMewsAvatar } from './styles';

interface UserMenuAvatarProps {
    onClick?: () => void;
}

const UserMenuAvatar: React.FC<UserMenuAvatarProps> = ({ onClick }) => {
    const activeAccount = useSelector(getCurrentUserMenuAccount);

    if (typeof activeAccount === 'undefined') {
        return null;
    }

    // @ts-expect-error $TSFixMeError: Property 'accountImageUrl' does not exist on type '{ enterpriseId: { toString: ...; charAt: ...; charCodeAt: ...; concat: ...; indexOf: ...; lastIndexOf: ...; localeCompare: ...; match: ...; replace: ...; search: ...; slice: ...; split: ...; substring: ...; ... 35 more ...; at: ...; }; } | undefined'.
    const { accountImageUrl, fullName, enterpriseImageUrl, name } = activeAccount;

    const subAvatarProps = {
        src: enterpriseImageUrl,
        title: name,
    };

    const mewsMenuAvatarProps = {
        onClick,
        size: 'medium' as const,
        src: accountImageUrl,
        title: fullName,
    };

    return (
        <UserAvatarContainer onClick={onClick} data-test-id={DataTestId.UserMenuAvatar} {...getDisableClickAwayProps()}>
            <MenuMewsAvatar {...mewsMenuAvatarProps} emblem={subAvatarProps} />
        </UserAvatarContainer>
    );
};

export default UserMenuAvatar;
